export const MY_TEAM_WIDGET_KEY = 'my-team';
export const RICH_TEXT_WIDGET_KEY = 'rich-text';
export const PERSON_LISTS_BY_DATE_WIDGET_KEY = 'person-lists-by-date';
export const DEFAULT_WIDGET_LAYOUT_ID = 'default';

// (Note - Dylan) Avatar diamater is 50; vertical margin is 16 and horizontal margin is 8
export const AVATAR_AREA = 58 * 66;
export const AVATAR_CONTAINER_HEIGHT = 182;
export const AVATAR_MULTI_TAB_CONTAINER_HEIGHT = 132;
